export default {
  Title: 'Availability',
  CardTitle: 'Work Hours',
  LastUpdated: 'Last updated #{lastUpdated}',
  Blurb: 'Book an intro call with CareQuilt to confirm current availability and discuss schedule flexibility',
};
